import { useQuery } from '@tanstack/react-query';
import { requestZeusFromBrowser } from 'components/api/zeusBrowserClient';
import { MarketplaceBrowseDocument } from 'components/marketplace/browse/__generated__/marketplace-browse.zeus';
import type { MarketplaceBrowseVariables } from 'components/marketplace/browse/marketplaceBrowse';

/**
 * How many homes a draft of the filters would match, before it is applied.
 * Asks for a single listing so the count is cheap; the sheet's Show button
 * reads it. Undefined until the first answer arrives, or without a draft.
 */
export const useDraftResultCount = (
  listInput: MarketplaceBrowseVariables['listInput'] | undefined,
): number | undefined => {
  const query = useQuery({
    queryKey: ['marketplace', 'draft-count', listInput],
    queryFn: ({ signal }) =>
      requestZeusFromBrowser(
        MarketplaceBrowseDocument,
        { input: { ...listInput!, first: 1, photoLimit: 1, page: 0 } },
        signal,
      ),
    enabled: Boolean(listInput),
    staleTime: 30_000,
    retry: false,
  });
  return query.data?.marketplace.listings.totalCount ?? undefined;
};
